var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":_vm.$t('quickSearches')}},[(_vm.isCustomerAdministrator)?_c('div',[_c('quick-user-search')],1):_vm._e(),(_vm.isCustomerAdministrator)?_c('div',{staticClass:"mt-4"},[_c('quick-organization-search')],1):_c('div',[_vm._v(_vm._s(_vm.$t('notAllowedToAccess')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }